import { Button, InPageAlert } from '@snsw/react-component-library';
import { RefData } from 'plantItemNew/constants/refData';
import { getInfoCodeValue } from 'plantItemRenewal/utils/PlantItemRenewalHelpers';
import React from 'react';
import { UploadedCertificates } from './UploadedCertificates';
import styles from '../Page.module.scss';
import _ from 'lodash';
import { InfoCode } from 'shared/constants/InfoCode';

export const ItemCertificates = ({ item, onAddCertificate }) => {
  if (item.tangibleType != RefData.plantItemType.amusementDevice) return null;

  const includeElectricalInstallation =
    getInfoCodeValue(item, InfoCode.electricalInstallation) === RefData.includeElectricalInstallation;

  if (
    (includeElectricalInstallation && _.isEmpty(item.electricalCertificates)) ||
    _.isEmpty(item.engineerCertificates)
  ) {
    return (
      <InPageAlert variant="warning" title="Please add an inspection certificate">
        <p>You must provide inspection certificates every time you renew your item registration.</p>
        <Button variant="secondary" className={styles.marginTopOneHalf} onClick={onAddCertificate}>
          + Add certificate
        </Button>
      </InPageAlert>
    );
  } else {
    return (
      <>
        {!_.isEmpty(item.engineerCertificates) && (
          <UploadedCertificates
            title="Uploaded mechanical/structural inspection certificate:"
            uploadedFile={item.engineerCertificates?.uploadedFiles[0]}
            onUpdate={onAddCertificate}
          />
        )}

        {!_.isEmpty(item.electricalCertificates) && (
          <UploadedCertificates
            title="Uploaded electrical inspection certificate:"
            uploadedFile={item.electricalCertificates?.uploadedFiles[0]}
            onUpdate={onAddCertificate}
          />
        )}
      </>
    );
  }
};
